import styled, { css } from "styled-components";
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import Toggle from "components/layout/Toggle";
import { breakpoints } from "styles/grid";

const StyledBlock = styled(Block)`
	display: flex;
	max-width: 100%;
	width: max-content;
	align-items: flex-start;
	padding: 0.25rem 0.5rem;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.element};
	user-select: none;

	${({ disabled }) =>
		disabled
			? css`
					cursor: no-drop;
					& ${Text} {
						opacity: var(--dz-sys-button-disabled-opacity);
					}
				`
			: css`
					cursor: pointer;
				`}
	&:hover {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
	}

	@media (max-width: ${breakpoints.phone - 1}px) {
		margin-left: -0.5rem;
	}
`;

export const TogglePreferences = ({
	toggled,
	disabled = false,
	dispatchAction,
	text,
}) => {
	return (
		<StyledBlock
			onClick={() => (disabled ? null : dispatchAction())}
			disabled={disabled}
		>
			<Block flex mr={2} style={{ height: "21px" }} alignCenter>
				<Toggle toggled={toggled} disabled={disabled} />
			</Block>
			<Text>{text}</Text>
		</StyledBlock>
	);
};
